import React from "react";
import "./image.scss";
const Image = ({ name, toggle, width, height, img, IssueImg }) => {
  const HandleURL = (e) => {
    e.preventDefault();

    //let encodedImg = encodeURIComponent(img);
// <<<<<<< test
//     let myURL = `${process.env.REACT_APP_FRONTEND_URL}/file/${img}`;
// =======
    let myURL = `https://erp.headtler.com/file/${img}`;
// >>>>>>> main

    window.open(myURL, "_blank");
  };

  return (
    <div className={"centerimg"}>
      {IssueImg ? (
        <a onClick={HandleURL}>
          <img
            className={name}
            width={width}
            height={height}
            src={img}
            alt="logo"
          />
        </a>
      ) : (
        <img
          className={name}
          onClick={toggle}
          width={width}
          height={height}
          src={img}
          alt="logo"
        />
      )}
    </div>
  );
};

export default Image;
